import AdminLinks from "components/Profile/AdminLinks";
import PropTypes from "prop-types";
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { isSessionActive } from "lib/currentUser/session";

export const ADMIN_ACTIONS_QUERY = gql`
  query ($path: String!) {
    adminActions (path: $path) { icon, label, path, trackAction }
  }
`;

const ProfileAdminLinksContainer = ({ path }) => {
  if (!isSessionActive()) {
    return null;
  }

  const { loading, error, data } = useQuery(ADMIN_ACTIONS_QUERY, {
    variables: { path },
  });

  if (loading) { return null; }
  if (error) { return null; }

  const { adminActions } = data;

  return <AdminLinks adminActions={adminActions} />;
};

ProfileAdminLinksContainer.propTypes = {
  path: PropTypes.string.isRequired,
};

export default ProfileAdminLinksContainer;
